import React, { useCallback } from "react";

import {
    Content,
    ContentBody,
    DialogContainer,
    DialogTop,
    DialogTopLeft,
    DialogTopCenter,
    DialogTopRight,
    NoCardsMessage
} from "./style";

import { AiOutlineClose } from "react-icons/ai";
import { MdOutlineFilterList } from "react-icons/md";
import { Card } from "../../../../../../interfaces/Card";
import { Flow } from "../../../../../../interfaces/Flow";
import { FilterFlowProps } from "../../../../../FilterBar/FilterDialog";
import ComboBoxFlowTable from "../ComboBoxFlowTable";
import FilterBar from "../../../../../FilterBar";


interface ComboBoxFlowAdvanceSelectProps {
    open: boolean;
    cards: Card[];
    flow: Flow;
    typeUser: string;
    onFilterFlow?: (filterFlow: FilterFlowProps, openedDialog: boolean) => void;
    filterFlow?: FilterFlowProps;
    isSelectableRows?: boolean;
    loading?: boolean
    onClose: () => void;
    onSelectCards?: (cards: Card[]) => Promise<void> | void;
}

const ComboBoxFlowAdvanceSelect: React.FC<ComboBoxFlowAdvanceSelectProps> = ({ onClose, open, cards, flow, typeUser, filterFlow, onFilterFlow, isSelectableRows, loading, onSelectCards }) => {

    const handleClose = useCallback(async () => {
        onClose();
    }, [onClose]);

    return (
        <DialogContainer
            fullWidth={true}
            maxWidth="lg"
            open={open}
            onClose={handleClose}
        >
            <DialogTop>
                <DialogTopLeft>
                    <h1>
                        {"Selecione os cartões do fluxo " + flow.name}
                    </h1>
                </DialogTopLeft>

                <DialogTopCenter />

                <DialogTopRight>
                    <button onClick={handleClose}><AiOutlineClose /></button>
                </DialogTopRight>
            </DialogTop>
            <Content>

                <FilterBar
                    flow={flow}
                    typeUser={typeUser}
                    itemNavBar={1}
                    isComboSelect={true}
                    isArchived={false}
                    onFilterFlow={onFilterFlow !== undefined ? onFilterFlow : () => { }}
                    onClickField={() => { }}
                    onAddElement={() => { }}
                    onSyncPanel={() => { }}
                    onRemoveArchived={() => { }}
                />

                <ContentBody container>
                    {!loading && cards.length > 0 ? (
                        <ComboBoxFlowTable
                            flow={flow}
                            typeUser={typeUser}
                            cards={cards}
                            filterFlow={filterFlow}
                            isSelectableRows={isSelectableRows}
                            loading={loading}
                            onRowClicked={() => { }}
                            onSelectCards={onSelectCards}
                        />
                    ) : (
                        <NoCardsMessage>
                            <MdOutlineFilterList />
                            <h3>Nenhum cartão disponível para seleção</h3>
                            <p>
                                Todos os cartões disponíveis já foram selecionados ou não existem cartões que atendam aos filtros aplicados.
                            </p>
                        </NoCardsMessage>
                    )}
                </ContentBody>
            </Content>
        </DialogContainer >
    );

}

export default ComboBoxFlowAdvanceSelect;